module.exports = __webpack_public_path__ + "img/team2.f4d48c64.png";